(() => {
  const dialog = document.querySelector('#om-between-search');
  if (!dialog) return;
  const input = dialog.querySelector('input[type=search]'), form = dialog.querySelector('form');
  const list = dialog.querySelector('ul'), status = dialog.querySelector('[data-search-status]'), all = dialog.querySelector('[data-search-all]');
  const copy = JSON.parse(dialog.querySelector('[data-search-copy]').textContent);
  const root = dialog.dataset.root || '/', currency = dialog.dataset.currency;
  let timer, controller, version = 0, effective = '', trigger;
  const aliases = copy.aliases.split(';').map(line => line.split('=').map(x => x.trim().toLowerCase())).filter(pair => pair.length === 2 && pair.every(Boolean));
  const normalize = q => aliases.reduce((q, [from,to]) => q.replace(new RegExp('(^|\\s)' + from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?=\\s|$)', 'gi'), '$1' + to), q);
  document.addEventListener('click', e => {
    const target = e.target.closest('a[href], [data-om-search-toggle]');
    if (!target || target.closest('#om-between-search') || (!target.hasAttribute('data-om-search-toggle') && new URL(target.href, location.origin).pathname !== root + 'search')) return;
    e.preventDefault(); e.stopImmediatePropagation(); trigger = target;
    if (!dialog.open) dialog.showModal(); trigger.setAttribute('aria-expanded','true'); input.focus();
  }, true);
  const close = () => { dialog.close(); trigger?.focus(); };
  dialog.querySelector('[data-search-close]').addEventListener('click', close);
  dialog.addEventListener('click', e => { if (e.target === dialog) close(); });
  dialog.addEventListener('close', () => { clearTimeout(timer); controller?.abort(); trigger?.setAttribute('aria-expanded','false'); trigger?.focus(); });
  dialog.addEventListener('keydown', e => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const links = [...list.querySelectorAll('a')]; if (!links.length) return;
    e.preventDefault(); const i = links.indexOf(document.activeElement);
    if (e.key === 'ArrowUp' && i <= 0) input.focus();
    else links[(i + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
  });
  async function request(q, signal) {
    const params = new URLSearchParams({q, 'resources[type]':'product', 'resources[limit]':'10', 'resources[options][unavailable_products]':'last'});
    const response = await fetch(root + 'search/suggest.json?' + params, {signal});
    if (!response.ok) throw new Error('Search unavailable');
    const excluded = copy.excluded.split(',').map(h => h.trim());
    return (await response.json()).resources.results.products.filter(p => !excluded.includes(p.handle));
  }
  input.addEventListener('input', () => {
    clearTimeout(timer); controller?.abort(); const current = ++version, q = input.value.trim();
    effective = q; list.replaceChildren(); all.hidden = true; input.setAttribute('aria-expanded','false'); status.textContent = '';
    if (!q) return;
    timer = setTimeout(async () => {
      controller = new AbortController(); list.setAttribute('aria-busy','true');
      try {
        let products = await request(q, controller.signal);
        const translated = normalize(q);
        if (translated !== q) {
          const mapped = await request(translated, controller.signal);
          if (mapped.length) { effective = translated; const seen = new Set(); products = [...mapped, ...products].filter(p => { if (seen.has(p.id)) return false; seen.add(p.id); return true; }).slice(0,10); }
        }
        if (current !== version || !dialog.open) return;
        const words = effective.toLowerCase().split(/\s+/);
        const score = p => words.reduce((sum,w) => sum + (p.title.toLowerCase().includes(w) ? 1 : 0), 0);
        products.sort((a,b) => score(b)-score(a));
        for (const p of products) {
          const li = document.createElement('li'), link = document.createElement('a'), text = document.createElement('span');
          link.href = p.url;
          if (p.featured_image?.url) { const img = document.createElement('img'); img.src = p.featured_image.url + (p.featured_image.url.includes('?')?'&':'?') + 'width=180'; img.alt = ''; img.width = 90; img.height = 110; link.append(img); }
          const title = document.createElement('strong'), name = document.createElement('span');
          title.dataset.productTitle = p.title;
          const boundary = p.title.lastIndexOf(' - ');
          name.className = 'om-product-name'; name.textContent = boundary > 0 ? p.title.slice(0, boundary) : p.title;
          title.append(name);
          if (boundary > 0) { const type = document.createElement('span'); type.className = 'om-product-type'; type.textContent = p.title.slice(boundary + 3); title.append(type); }
          text.append(title);
          const price = document.createElement('span'); price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(Number(p.price)); text.append(price);
          if (!p.available) { const note = document.createElement('span'); note.textContent = copy.unavailable; text.append(note); }
          link.append(text); li.append(link); list.append(li);
        }
        status.textContent = products.length ? (effective !== q ? q + ' → ' + effective + ' · ' : '') + products.length + ' ' + copy.products : copy.empty.replace('__QUERY__', q);
        all.href = root + 'search?' + new URLSearchParams({q:effective,type:'product','options[prefix]':'last','options[unavailable_products]':'last'});
        all.hidden = false; input.setAttribute('aria-expanded',String(products.length > 0));
      } catch (e) {
        if (e.name !== 'AbortError' && current === version) { status.textContent = copy.error; all.href = root + 'search?' + new URLSearchParams({q,type:'product'}); all.hidden = false; }
      } finally { if (current === version) list.removeAttribute('aria-busy'); }
    },180);
  });
  form.addEventListener('submit', () => { input.value = effective || input.value; });
})();
